import { render } from "./CollectionBanner.vue?vue&type=template&id=45171d2e"
import script from "./CollectionBanner.vue?vue&type=script&lang=js"
export * from "./CollectionBanner.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__